import React from 'react';
import {vedsEmail} from "../../constants";

import './footer.css';

export const Footer = () => {
    return (
        <div className="container-fluid section-padding-sm">
            <div className="container">
                <h3 className="text-center text-red mb-4">FOLLOW US</h3>
                <div className="d-flex justify-content-center mb-4">
                    <a href="https://www.facebook.com/profile.php?id=61560437403113">
                        <img className="svg-social fa-2x text-red" src="/img/facebook.svg" alt="Link to Bellas Mission Official Facebook Page"/>
                    </a>
                    <a href="https://instagram.com/bellasmission">
                        <img className="svg-social fa-2x text-red" src="/img/instagram.svg" alt="Link to Bellas Mission Official Instagram"/>
                    </a>
                </div>
                <p className="text-center">
                    For questions or concerns please reach out to: <a href={`mailto:${vedsEmail}`}>{vedsEmail}</a>
                </p>
                <p className="text-center text-muted">
                    © {new Date().getFullYear()} Bella's Mission Inc. All rights reserved.
                </p>
            </div>
        </div>
    );
};

